export default "__VITE_ASSET__BD9lvg9R__"